module.exports = __webpack_public_path__ + "img/icon-16-ic-arrow-n.38e4d351.svg";